import { useEffect } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const VisitorTracker = () => {
  useEffect(() => {
    const pingVisitor = async () => {
      try {
        await fetch(`${API_URL}/api/visitors/ping`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            page: window.location.pathname,
            referrer: document.referrer || null
          })
        });
      } catch (err) {
        // Silent fail - don't disrupt user experience
      }
    };

    // Initial ping
    pingVisitor();

    // Ping every 30 seconds while user is on site
    const interval = setInterval(pingVisitor, 30000);

    // Ping on page visibility change (when user returns to tab)
    const handleVisibility = () => {
      if (document.visibilityState === 'visible') {
        pingVisitor();
      }
    };
    document.addEventListener('visibilitychange', handleVisibility);

    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, []);

  return null; // This component doesn't render anything
};

export default VisitorTracker;
